import type { PaymentPageFormData } from "@/pages/payment-pages/types/payment-page";

// The page's copy fields, as edited (JSON text) → as saved (parsed JSON).
export const COPY_FIELDS = [
  ["description", "Description"],
  ["plan_details", "Plan Details"],
  ["tnc", "TnC"],
  ["how_it_works", "How It Works"],
] as const;

// Everything on the page that can carry a price tag, shaped as the server
// stores it — the JSON boxes parsed, plus the add-on's label and description.
// The save check and the preview both read this, so a tag in any of them is
// checked and previewed the same way. Throws on a JSON box that does not parse.
export function parseCopy(data: Partial<PaymentPageFormData>) {
  const copy: Record<string, unknown> = Object.fromEntries(
    COPY_FIELDS.map(([name, label]) => {
      const raw = data[name]?.trim();
      if (!raw) return [name, undefined];
      try {
        return [name, JSON.parse(raw)];
      } catch {
        throw new Error(`${label} is not valid JSON.`);
      }
    }),
  );

  const label = data.add_on?.label?.trim();
  const description = data.add_on?.description?.trim();
  copy.add_on =
    label || description
      ? {
          ...(label ? { label } : {}),
          ...(description ? { description } : {}),
        }
      : undefined;

  return copy;
}
